(function () {
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function initGallery(gallery) {
    var list = gallery.querySelector('.product__media-list');
    if (!list) return;

    function activeSlideHeight() {
      var slides = Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
      if (!slides.length) return null;

      var width = list.clientWidth || 1;
      var index = Math.round(list.scrollLeft / width);
      index = Math.max(0, Math.min(index, slides.length - 1));

      var media = slides[index].querySelector('.product__media') || slides[index];
      var height = media.getBoundingClientRect().height;
      return height > 0 ? height : null;
    }

    function update() {
      if (!mobileQuery.matches) {
        list.style.height = '';
        return;
      }
      var height = activeSlideHeight();
      if (height) list.style.height = Math.round(height) + 'px';
    }

    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', update);
    }

    // Image 'load' events don't bubble, but a capture-phase listener on an
    // ancestor still observes them on the way down, so this catches every
    // lazily-loaded slide image finishing after the user has scrolled to it.
    list.addEventListener('load', update, { capture: true, passive: true });

    update();
    window.setTimeout(update, 150);
  }

  var desktopQuery = window.matchMedia('(min-width: 750px)');

  // On desktop only .is-active media item is visible (see
  // section-canva-design-product.css), so the built-in slider's scroll-based
  // prev/next math has nothing to scroll. Drive it explicitly instead, reusing
  // the gallery's own setActiveMedia so thumbnails/live-region stay in sync.
  function initDesktopArrows(gallery) {
    var viewer = gallery.querySelector('product-gallery');
    if (!viewer) return;
    var list = viewer.querySelector('.product__media-list');
    if (!list) return;
    var slides = Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
    if (slides.length < 2) return;

    var buttons = viewer.querySelectorAll(':scope > .slider-buttons .slider-button');
    var prevButton = null;
    var nextButton = null;
    buttons.forEach(function (button) {
      if (button.classList.contains('slider-button--prev')) prevButton = button;
      if (button.classList.contains('slider-button--next')) nextButton = button;
    });
    if (!prevButton && !nextButton) return;

    function goTo(step) {
      if (!desktopQuery.matches || typeof gallery.setActiveMedia !== 'function') return;
      var current = slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });
      if (current === -1) current = 0;
      var target = slides[(current + step + slides.length) % slides.length];
      gallery.setActiveMedia(target.dataset.mediaId, false, false);
    }

    if (prevButton) prevButton.addEventListener('click', function () { goTo(-1); });
    if (nextButton) nextButton.addEventListener('click', function () { goTo(1); });
  }

  function init() {
    document.querySelectorAll('.cdp__media media-gallery').forEach(function (gallery) {
      initGallery(gallery);
      initDesktopArrows(gallery);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
